namespace Nobox.CRM {
    export interface ProductdealsRow {
        Id?: number;
        DealId?: number;
        PdtId?: number;
        PdtIdNm?: string;
        Currencies?: string;
        PdtPrc?: number;
        PdtQty?: number;
        PdtDisc?: number;
        PdtTotal?: number;
        PdtImg?: string;
        PdtDesc?: string;
        PdtCd?: string;
        UnitIds?: string;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
    }

    export namespace ProductdealsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PdtId';
        export const localTextPrefix = 'Nobox.Productdeals';
        export const lookupKey = 'Nobox.Productdeals';

        export function getLookup(): Q.Lookup<ProductdealsRow> {
            return Q.getLookup<ProductdealsRow>('Nobox.Productdeals');
        }
        export const deletePermission = 'Deals:Delete';
        export const insertPermission = 'Deals:Modify';
        export const readPermission = 'Deals:View';
        export const updatePermission = 'Deals:Modify';

        export declare const enum Fields {
            Id = "Id",
            DealId = "DealId",
            PdtId = "PdtId",
            PdtIdNm = "PdtIdNm",
            Currencies = "Currencies",
            PdtPrc = "PdtPrc",
            PdtQty = "PdtQty",
            PdtDisc = "PdtDisc",
            PdtTotal = "PdtTotal",
            PdtImg = "PdtImg",
            PdtDesc = "PdtDesc",
            PdtCd = "PdtCd",
            UnitIds = "UnitIds",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy"
        }
    }
}
